// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { footerContainerStyles } from "@turnerBlueprint/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@turnerBlueprint/XDL/constants";
import { color, layoutContainer, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

footerContainerStyles.widgetGridContainer = {
    gap: 0,
    offsetCss: css`
        && {
            gap: 22px;
            ${xScreen("lte", "md")} {
                gap: 0;
            }
        }
    `,
    css: css`
        ${layoutContainer}
        &&& {
            ${xScreen("lte", "md")} {
                padding: 0;
            }
        }
    `,
};

footerContainerStyles.linkList1GridItem =
    footerContainerStyles.linkList2GridItem =
    footerContainerStyles.linkList3GridItem =
    footerContainerStyles.linkList4GridItem =
        {
            css: css`
                flex-direction: column;
                gap: 12px;
                &&& {
                    max-width: unset;
                }

                a:not(:disabled):visited {
                    &,
                    & > ${TypographyStyle}, & ${IconWrapper} {
                        color: ${color("common.white")};
                    }
                }
            `,
        };

footerContainerStyles.subscribeContainer = {
    css: css`
        position: relative;
        background-color: ${color("common.black")};
        flex-direction: column;
        display: flex;
        width: 432px;
        gap: 25px;
        padding: 20px 16px 20px 20px;

        ${xScreen("lte", "md")} {
            width: 374px;
            padding: 20px 20px 20px 16px;
        }
        ${xScreen("lt", "sm")} {
            width: 100%;
            padding: 20px 16px;
        }
    `,
};

footerContainerStyles.copyrightContainer = {
    css: css`
        display: flex;
        flex: 1;
        justify-content: end;
    `,
};

footerContainerStyles.copyrightText = {
    size: 12,
    lineHeight: "20px",
    color: "common.white",
    css: css`
        ${({ isCheckoutPage }: any) =>
            isCheckoutPage &&
            css`
                margin-right: auto;
            `}
        ${xScreen("lte", "xs")} {
            ${BLUEPRINT_NAME === "turnerScienceBlueprint" &&
            css`
                margin-right: auto;
            `}
        }
    `,
};

footerContainerStyles.logoWrapper = {
    css: css`
        position: absolute;
        right: 20px;
        bottom: 20px;
        ${xScreen("lte", "sm")} {
            right: 16px;
            bottom: 16px;
        }
        &.CMS {
            position: static;
        }
    `,
};

footerContainerStyles.rightSideContainer = {
    gap: 0,
    offsetCss: css`
        &&& {
            gap: 20px 22px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            ${xScreen("lte", "md")} {
                grid-template-columns: repeat(2, 1fr);
                gap: 20px 24px;
            }
        }
    `,
};

footerContainerStyles.socialLinks = {
    css: css`
        ${DivWrapper} {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    `,
};

footerContainerStyles.rightSide = {
    css: css`
        display: flex;
        flex: 1;
        padding: 20px 0 12px 0;
        flex-direction: column;
        gap: 32px;
        ${xScreen("lte", "md")} {
            padding: 20px 16px 16px;
        }
    `,
};

footerContainerStyles.siteMapLinksGridItem = {
    css: css`
        .links-wrapper {
            gap: 20px;
        }
    `,
};
